// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* 路由 */
import router from './router'

/* i18n */
import i18n from './lang'

import store from './store'

/* swiper */
import 'swiper/dist/css/swiper.min.css';


// import 'amfe-flexible'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'


/* animate.css */
import 'animate.css'


/* 重置样式 */
import './assets/css/reset.min.css'

import './assets/css/index.css'

// 适配小屏幕尺寸
// import '!style-loader!css-loader!less-loader!./my-theme/coustom.less'


/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)
/*外链*/
import ExternalLink from './components/ExternalLink.vue'
Vue.component(ExternalLink.name,ExternalLink)

import CatDialog from "./components/Dialog.vue";
Vue.component(CatDialog.name, CatDialog);

Vue.config.productionTip = false

console.log(i18n)
router.beforeEach((to, from, next) => {
  // Handle legacy ?lang= query param - redirect to path-based URL
  const langQuery = to.query.lang
  if (langQuery === 'en' || langQuery === 'cn') {
    const path = to.path.replace(/^\/(en|cn)/, '') || '/home'
    next({ path: `/${langQuery}${path}`, replace: true })
    return
  }

  // Read language from path parameter
  const lang = to.params.lang
  if (lang === 'en') {
    localStorage.setItem('lang', 'EN')
    i18n.locale = 'en'
    document.documentElement.setAttribute('lang', 'en')
  } else if (lang === 'cn') {
    localStorage.setItem('lang', 'CN')
    i18n.locale = 'zn'
    document.documentElement.setAttribute('lang', 'zh')
  } else {
    // No lang param (e.g., root path) - use localStorage
    const saved = localStorage.getItem('lang')
    if (saved === 'CN') {
      i18n.locale = 'zn'
      document.documentElement.setAttribute('lang', 'zh')
    } else {
      localStorage.setItem('lang', 'EN')
      i18n.locale = 'en'
      document.documentElement.setAttribute('lang', 'en')
    }
  }

  // Update canonical URL based on current path
  const currentLang = lang || (localStorage.getItem('lang') === 'CN' ? 'cn' : 'en')
  const stripped = to.path.replace(/^\/(en|cn)/, '')
  const pathWithoutLang = (!stripped || stripped === '/') ? '/home' : stripped
  const canonical = document.querySelector('link[rel="canonical"]')
  if (canonical) {
    canonical.setAttribute('href', `https://www.kanglinbio.com/${currentLang}${pathWithoutLang}`)
  }

  // Update hreflang tags
  const hreflangEn = document.querySelector('link[hreflang="en"]')
  const hreflangZh = document.querySelector('link[hreflang="zh-CN"]')
  const hreflangDefault = document.querySelector('link[hreflang="x-default"]')
  if (hreflangEn) {
    hreflangEn.setAttribute('href', `https://www.kanglinbio.com/en${pathWithoutLang}`)
  }
  if (hreflangZh) {
    hreflangZh.setAttribute('href', `https://www.kanglinbio.com/cn${pathWithoutLang}`)
  }
  if (hreflangDefault) {
    hreflangDefault.setAttribute('href', `https://www.kanglinbio.com/en${pathWithoutLang}`)
  }

  if(to.meta.title){
    document.title = i18n.t(to.meta.title)
  }

  // Update page-specific keywords
  const keywordsMeta = document.querySelector('meta[name="keywords"]')
  if (keywordsMeta) {
    if (to.meta.keywords) {
      keywordsMeta.setAttribute('content', i18n.t(to.meta.keywords))
    } else {
      // Fallback to global keywords
      keywordsMeta.setAttribute('content', i18n.t('gsxg.keywords'))
    }
  }

  // Update page-specific description
  const descMeta = document.querySelector('meta[name="description"]')
  if (descMeta) {
    if (to.meta.description) {
      descMeta.setAttribute('content', i18n.t(to.meta.description))
    } else {
      // Fallback to global description
      descMeta.setAttribute('content', i18n.t('gsxg.description'))
    }
  }

  next();
});


new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js